export const useLocalFilter = (input: string, option): boolean => {
  return (
    option.componentOptions.children[0].componentOptions.children[1].text
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0
  );
};
